module.exports = __webpack_public_path__ + "static/media/01B.1fede99b.png";